import React, { useEffect, useRef, useState, useContext } from 'react';
import DosageSelection from './DosageSelection.jsx';
import _ from 'lodash';
import { DEFAULT_ZIPCODE } from '../../../constants/defaults';
import { withRouter } from 'react-router-dom';
const { API } = require('../../../config/' + process.env.REACT_APP_ENV);
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { useTranslation } from 'react-i18next';
import SkipTo from '../../common/Tag/SkipTo';
import loadable from '@loadable/component';
import SaveDrug from './SaveDrug';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../../Contexts.js';
import LazyImageWithNoscript from '../../common/LazyImageWithNoscript/index.js';
const DosageSelectionMobileNew = loadable(() =>
  import('./DosageSelectionMobileNew')
);
const PriceAlerts = loadable(() => import('./PriceAlerts'));

const DrugDosageDescription = props => {
  const [showModal, setShowModal] = useState(false);
  const [selectedbrand, setSelectedBrand] = useState(props.drugName || '');
  const [showMore, setShowMore] = useState(false);
  const [showReadMore, setShowReadMore] = useState(true);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [showNewModal, setShowNewModal] = useState(false);
  const editBtnRef = useRef(null);
  const { t, i18n } = useTranslation();

  //get query paramters and check if user is coming from home seach for AB Testing
  const { search } = useLocation();
  const isHomeSearch = new URLSearchParams(search)?.get('isHomeSearch');
  //get user context to check if user is loggedout for AB Testing
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;

  const {
    defaultKeys = {
      dosage: '',
      form: '',
      isSpecialtyDrug: false,
      isGlobalSuppressionDrug: false
    },
    isSpecialityDrugNew = false,
    showTieredPricingLoader,
    isAdSuppressed,
    isHealthCareProviderAcquirable,
    isNormalDrug,
    brandTypes = [{ seoname: '', brand: '' }],
    doNotMarket = false,
    customQuantity,
    drugNdc,
    zipCode,
    lowestPriceForAleart,
    userName,
    isFromCouponPage = false
  } = props;
  const { drug, imageUrl, cmsData } = props.drugDescription;
  const { brandId, dosageId, formId, quantityId } = props.drugIds;
  const formTypes = !_.isEmpty(brandTypes) && brandTypes[brandId].formTypes;
  const { dosage } = !_.isEmpty(formTypes) && formTypes[formId];
  const { quantities } = !_.isEmpty(dosage) && dosage[dosageId];
  let selectedForm = formTypes && formTypes[formId].name;
  let selectedDosage = dosage && dosage[dosageId].dosage;
  let selectedQuantity = quantities && quantities[quantityId].displayQuantity;
  let finalQty = quantities && quantities[quantityId].quantity;
  let drugTitle =
    !_.isEmpty(defaultKeys?.cmsSubTitle) ||
    (!_.isEmpty(defaultKeys?.subTitle) &&
      !_.isEmpty(defaultKeys?.drugInformationDrugType));

  useEffect(() => {
    let element = document.getElementById('description');
    if (element) setShowReadMore(element.offsetHeight > 50);
  }, []);

  const handleMobileModal = () => {
    if (
      editBtnRef.current &&
      editBtnRef.current.classList.contains('showNewModal')
    ) {
      if (!showNewModal) document.body.style.overflow = 'hidden';
      _.triggerGTMVirtualPageViewEvent({
        ...props.dataLayerEventObj,
        event: 'drugFiltersEditButtonClick',
        formId: 'dosage',
        clickText: 'Edit'
      });
      setShowNewModal(!showNewModal);
    } else {
      if (!showModal) {
        _.triggerGTMVirtualPageViewEvent({
          ...props.dataLayerEventObj,
          event: 'drugFiltersEditButtonClick',
          formId: 'dosage',
          clickText: 'Edit'
        });
      }
      setShowModal(!showModal);
    }
  };

  const handleCloseModal = () => {
    setShowNewModal(false);
  };

  const togglePriceModal = zipcode => {
    setShowPriceModal(!showPriceModal);
    if (zipcode && !_.isEqual(zipcode, zipCode)) {
      props.handleZipCodeChange(zipcode);
    }
  };

  const handleBrandSelect = selectedbrand => {
    setShowPriceModal(showPriceModal);
    setSelectedBrand(selectedbrand);
  };

  return (
    <div
      id={t('ID DRUGS')}
      className={`InnerFilterSection ${
        !isAdSuppressed ? '' : 'drugPaddingRemove'
      }`}
    >
      <div className="drug-pricing--filters-section">
        <div
          id="selected-drug-values"
          className={`drug-titles ${_.isEmpty(imageUrl) ? 'moveZipCode' : ''}`}
        >
          <div
            className={`d-flex flex-column borderLine ${
              _.isEmpty(imageUrl) && 'emptyImage'
            }`}
          >
            <div className="d-flex flex-row">
              {!_.isEmpty(imageUrl) ? (
                <div className="drugImgCol">
                  <div className={`d-flex drug-icon desktop-only`}>
                    <div className="drugImage">
                      <LazyImageWithNoscript
                        src={imageUrl}
                        alt={`${drug && drug?.name} coupon - ${
                          drug && drug?.name
                        } ${defaultKeys.dosage} ${defaultKeys.form}`}
                        height="100"
                        width="134"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}

              <div className="d-flex flex-column w-100 dataInfo">
                <SkipTo>
                  {!isFromCouponPage ? (
                    <h1
                      id="drug-name-headline"
                      className={`main-hotswap-drug-name ${
                        isHealthCareProviderAcquirable ? 'fontSmall' : ''
                      }`}
                    >
                      {cmsData.name}{' '}
                      {isNormalDrug && <span>{t('Coupons & Prices')}</span>}
                    </h1>
                  ) : (
                    <h1
                      id="drug-name-headline"
                      className={`main-hotswap-drug-name ${
                        isHealthCareProviderAcquirable ? 'fontSmall' : ''
                      } drugHeadMain`}
                    >
                      {cmsData.name}&nbsp;<span>{'Coupons'}</span>
                    </h1>
                  )}
                </SkipTo>
                <div
                  className={`subTypeSection ${!drugTitle ? 'flexEnd' : ''} ${
                    isNormalDrug ? '' : 'paddingBottom20'
                  } `}
                >
                  {drugTitle && (
                    <h2 className="main-hotswap-generic-name">
                      {defaultKeys?.drugInformationDrugType ? (
                        <label>{`${defaultKeys?.drugInformationDrugType} ${t(
                          'for'
                        )}`}</label>
                      ) : defaultKeys?.cmsSubTitleGeneric ? (
                        <label>{t('Brand for')}</label>
                      ) : (
                        <label>{t('Generic for')}</label>
                      )}
                      <a
                        href={`${_.withLocale(
                          i18n.language,
                          '/prescription'
                        )}/${
                          defaultKeys?.subTitleSeoName
                            ? defaultKeys?.subTitleSeoName
                            : defaultKeys?.cmsSubSeoName
                        }${t('#coupons')}`}
                      >
                        {defaultKeys?.subTitle
                          ? defaultKeys?.subTitle
                          : defaultKeys?.cmsSubTitle}
                      </a>
                    </h2>
                  )}

                  {doNotMarket && (
                    <p className="controlled-flag desktop-only">
                      <a
                        href="https://www.singlecare.com/blog/controlled-substances-act/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="controller-substances-link"
                      >
                        <span>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {t('Controlled Substance')}
                        </span>
                      </a>
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex flex-column w-100 dataInfo">
              <div
                id="drugTreatment"
                className={
                  API.ALLOW_PRICE_ALERT &&
                  !defaultKeys.isGlobalSuppressionDrug &&
                  !isAdSuppressed
                    ? ''
                    : 'noPriceAlert'
                }
              >
                <div
                  className={`drug-treatment ${
                    showMore ? 'showMoreDescription' : 'showLessDescription'
                  }`}
                >
                  {cmsData && cmsData?.description ? (
                    <div id="description">
                      {documentToReactComponents(
                        cmsData && cmsData?.description
                      )}
                      {cmsData?.description?.length !== 0 && showReadMore && (
                        <button
                          className="actionInfoData"
                          onClick={() => setShowMore(!showMore)}
                        >
                          {showMore ? t('Less') : t('More')}
                          <span></span>
                        </button>
                      )}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                {API.ALLOW_PRICE_ALERT &&
                  i18n.language === 'en' &&
                  !defaultKeys.isGlobalSuppressionDrug &&
                  !isSpecialityDrugNew &&
                  !isAdSuppressed && (
                    <div className="mobile-only">
                      <div className="savePriceAlertWrap">
                        <SaveDrug
                          drugNDC={drugNdc}
                          quantity={
                            !_.isEmpty(customQuantity)
                              ? customQuantity
                              : finalQty
                          }
                          kclass={'mobile-only'}
                          ispricingInProgress={showTieredPricingLoader}
                          isCustomQuantity={!_.isEmpty(customQuantity)}
                        />
                        <div
                          role="dialog"
                          aria-haspopup="dialog"
                          className="priceAlert price-alerts-cta"
                          onClick={event => {
                            event.preventDefault;
                            togglePriceModal();
                          }}
                        >
                          <span className="priceAlertsIcon"></span>
                          <label>{t('Price Alerts')}</label>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
              {isNormalDrug && !defaultKeys.isGlobalSuppressionDrug && (
                <DosageSelection
                  handleBrandChange={props.handleBrandChange}
                  handleFormUpdate={props.handleFormUpdate}
                  handleDosageUpdate={props.handleDosageUpdate}
                  handleQuantityUpdate={props.handleQuantityUpdate}
                  brandTypes={brandTypes}
                  formTypes={props.formTypes}
                  dosageData={props.dosageData}
                  brandId={props.brandId}
                  dosageId={props.dosageId}
                  defaultStructure={props.defaultStructure}
                  defaultKeys={props.defaultKeys}
                  drugIds={props.drugIds}
                  updateDosage={props.updateDosage}
                  customQuantity={customQuantity}
                  drugNdc={drugNdc}
                  zipCode={zipCode}
                  drugName={drug && drug?.name}
                  lowestPrice={props.lowestPrice}
                  handleZipCodeChange={props.handleZipCodeChange}
                  lowestPriceForAleart={lowestPriceForAleart}
                  seoName={drug && drug?.seoName}
                  finalQty={finalQty}
                  dataLayerEventObj={props.dataLayerEventObj}
                  isSpecialityDrug={isSpecialityDrugNew}
                  isSuppressedDrug={props.isSuppressedDrug}
                  userName={userName}
                  patientCompassData={props.patientCompassData}
                  showTieredPricingLoader={showTieredPricingLoader}
                />
              )}
              {showNewModal &&
              !defaultKeys.isSpecialtyDrug &&
              !defaultKeys.isGlobalSuppressionDrug ? (
                <DosageSelectionMobileNew
                  handleBrandSelect={handleBrandSelect}
                  showModal={showNewModal}
                  toggleModal={handleMobileModal}
                  handleMobilePricing={props.handleMobilePricing}
                  setSelectedIds={props.setSelectedIds}
                  handleCloseModal={handleCloseModal}
                  {...props}
                />
              ) : null}

              {isHomeSearch &&
                !isLoggedIn &&
                !defaultKeys.isSpecialtyDrug &&
                !defaultKeys.isGlobalSuppressionDrug && (
                  /*Adding Edit Dsoage modal for mobile view 
                 if user is coming from home seach for AB Testing*/
                  <div id="mobileEditModal" className="appflowAbTest">
                    <DosageSelectionMobileNew
                      handleBrandSelect={handleBrandSelect}
                      showModal={isHomeSearch && !isLoggedIn}
                      toggleModal={handleMobileModal}
                      handleMobilePricing={props.handleMobilePricing}
                      setSelectedIds={props.setSelectedIds}
                      handleCloseModal={handleCloseModal}
                      {...props}
                    />
                  </div>
                )}
            </div>
          </div>

          {showPriceModal &&
            i18n.language === 'en' &&
            !defaultKeys.isGlobalSuppressionDrug && (
              <PriceAlerts
                drugNdc={drugNdc}
                hidepriceModal={togglePriceModal}
                drugName={selectedbrand}
                selectedDosage={_.toLower(selectedDosage)}
                quantity={
                  !_.isEmpty(customQuantity) ? customQuantity : selectedQuantity
                }
                form={selectedForm}
                lowestPrice={lowestPriceForAleart}
                zipcodeValue={
                  _.isEqual(zipCode, DEFAULT_ZIPCODE) ? '' : zipCode
                }
                seoName={drug && drug?.seoName}
                finalQty={
                  !_.isEmpty(customQuantity) ? customQuantity : finalQty
                }
                isCustomQuantity={!_.isEmpty(customQuantity) ? true : false}
                userName={userName}
              />
            )}

          {isNormalDrug && (
            <p
              className="drug-pricing--filters showNewModal whiteFocus"
              onClick={handleMobileModal}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  handleMobileModal;
                }
              }}
              ref={editBtnRef}
              role="button"
              tabIndex="0"
            >
              <span className="filter-amt--qty drug-hotswap-drug-qty">
                {!_.isEmpty(customQuantity) ? customQuantity : selectedQuantity}
                &nbsp;
                {selectedForm}
                ,&nbsp;
                {_.toLower(selectedDosage)}
              </span>
              <span className="filters-edit--cta sc-text-btn--cyan sc-btn--open-rx-filter">
                {t('Edit')}
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(DrugDosageDescription);
